(ns shared.core.components.modals.views
  (:require [shared.core.components.modals.data]
            [shared.core.components.icon :as icon]
            [shared.core.style :as style]
            [shared.core.components.theme :as theme]
            [shared.core.util :as util]
            [shared.core.components.h :as h]
            [shared.core.components.button :as button]
            [keybind.core :as key]
            [shared.core.keybind.views :as keybind]
            [shared.core.reactive :as re]
            [re-frame.core :as rf]
            [clojure.string :as s]))

(defmulti
  modal-view
  identity)

(defn modal [{:keys [background-click x-click close-on-esc? on-esc on-esc-text esc-bind?]
              :or {background-click #(rf/dispatch [:modals/hide])
                   on-esc-text "Close Modal"
                   esc-bind? true
                   close-on-esc? true}} _]
  (let [vw- (re/subscribe [:core/viewport-width])]
    (re/create-class
      {:component-did-mount #(when esc-bind?
                               (key/bind! "esc"
                                          ::modal-close
                                          (fn [_]
                                            (if on-esc (on-esc) (when close-on-esc? (re/dispatch [:modals/hide])))
                                            (when x-click (x-click))
                                            (when background-click (background-click)))))
       :component-will-unmount #(when esc-bind? (key/unbind! "esc" ::modal-close))
       :reagent-render (fn [{:keys [backdrop-style backgroundless? style animate? container-style fullscreen? show-x?
                                    data-modal-style done-button? done-text header sub-header done-button-theme
                                    fullscreen-gap icon-type icon-style dark-theme-style done-button-style
                                    done-button-hover-style header-style sub-header-style remove-scrollbar?]
                             :or {animate? false
                                  show-x? true
                                  done-text "Done"
                                  fullscreen-gap 0}}
                            & contents]
                         (let [mobile? (< @vw- 900)
                               backdrop-style (merge {:cursor (when background-click :pointer)
                                                      :display :flex
                                                      :align-items :center
                                                      :justify-content :center
                                                      :position :fixed
                                                      :top 0
                                                      :left 0
                                                      :width "100%"
                                                      :height "100%"
                                                      :background (util/hex->rgba (style/color :gray :base) 0.92)
                                                      :z-index (dec (style/z :above-all))}
                                                     backdrop-style)
                               double-fs-gap (* fullscreen-gap 2)]
                           [theme/theme
                            :div {:style backdrop-style
                                  :theme (style/dark-style {:background (util/hex->rgba (style/dark-color :background :lighter-3) 0.92)})
                                  :on-click background-click}
                            (when (and show-x? (or background-click x-click close-on-esc? on-esc))
                              (cond
                                done-button?
                                [(condp = done-button-theme
                                   :red button/red-button
                                   :red-outline button/red-outline-button
                                   button/green-button)
                                 {:style (merge {:position :absolute
                                                 :top (+ 10 fullscreen-gap)
                                                 :right (+ 10 fullscreen-gap)
                                                 :z-index (dec (style/z :above-all))}
                                                done-button-style)
                                  :hover-style done-button-hover-style
                                  :size (when mobile? :small)
                                  :on-click x-click}
                                 done-text]

                                (or close-on-esc? on-esc)
                                [:div {:on-click (or on-esc #(re/dispatch [:modals/hide]))
                                       :style {:background-color (style/color :gray :shade-8)
                                               :cursor :pointer
                                               :padding 10
                                               :position :absolute
                                               :top 10
                                               :right 10
                                               :z-index (style/z :low)}}
                                 [keybind/keybind-text {:key "esc"
                                                        :label on-esc-text
                                                        :label-style {:font-size 14}
                                                        :keybind-style {:font-size 13}}]]

                                (or background-click x-click)
                                [icon/material-icon {:icon-type :close
                                                     :style {:color (style/color :white :base)
                                                             :font-size 28
                                                             :cursor :pointer
                                                             :position :absolute
                                                             :top (+ 10 fullscreen-gap)
                                                             :right (+ 10 fullscreen-gap)}
                                                     :on-click x-click}]))
                            [:div {:data-modal true
                                   :style (merge (when (and (not fullscreen?)
                                                            (not remove-scrollbar?))
                                                   (util/momentum-scroll-y-style {:flex "1 0 auto"
                                                                                  :height "100%"
                                                                                  :width "100%"}))
                                                 data-modal-style)}
                             [:div {:style (merge {:flex "1 0 auto"
                                                   :display :flex
                                                   :align-items :center
                                                   :justify-content :center
                                                   :margin "120px 0 80px"
                                                   :min-height "calc(100% - 200px)"}
                                                  (when mobile?
                                                    {:margin "48px 0"})
                                                  (when fullscreen?
                                                    {:margin 0
                                                     :min-width (str "calc(100vw - " double-fs-gap "px)")
                                                     :min-height (str "calc(100vh - " double-fs-gap "px)")})
                                                  container-style)}
                              (into [theme/theme
                                     :div {:class-name (when animate? "animate__animated animate__slideInUp")
                                           :style (merge {:animation-duration "0.3s"
                                                          :background-color (style/color :white :base)
                                                          :border-radius 3
                                                          :box-shadow "rgba(0, 0, 0, 0.32) 0px 0px 6px 0px"
                                                          :cursor :default
                                                          :flex "0 0 auto"
                                                          :display :flex
                                                          :flex-direction :column
                                                          :align-items :center
                                                          :justify-content :center
                                                          :padding "50px 40px 55px"
                                                          :width 500
                                                          :max-width "90%"}
                                                         (when mobile?
                                                           {:padding "30px 20px 35px"})
                                                         (when fullscreen?
                                                           {:padding fullscreen-gap
                                                            :height (str "calc(100vh - " double-fs-gap "px)")
                                                            :width (str "calc(100vw - " double-fs-gap "px)")
                                                            :max-width (str "calc(100vw - " double-fs-gap "px)")})
                                                         (when backgroundless?
                                                           {:background-color :none
                                                            :border-radius 0
                                                            :box-shadow :none
                                                            :padding 0})
                                                         style)
                                           :theme (style/dark-style (merge {:background-color (style/dark-color :surface :base)}
                                                                           dark-theme-style))
                                           :on-click #(.stopPropagation %)}
                                     (when icon-type
                                       [icon/material-icon {:icon-type icon-type
                                                            :style (merge {:font-size 48
                                                                           :margin-bottom 16}
                                                                          icon-style)}])
                                     (when (not (s/blank? header))
                                       [h/h2 {:style (merge {:text-align :center
                                                             :flex "0 0 auto"}
                                                            header-style)}
                                        header])
                                     (when (not (s/blank? sub-header))
                                       [theme/theme
                                        :div {:style (merge {:color (style/color :gray :base)
                                                             :font-size 16
                                                             :line-height 1.3
                                                             :text-align :center
                                                             :flex "0 0 auto"
                                                             :margin-top 5}
                                                            sub-header-style)
                                              :theme (style/dark-style {:color (style/dark-color :on-surface :base)})}
                                        sub-header])]
                                    contents)]]]))})))

(defmethod modal-view
  :modals/confirm-modal [_ {:keys [message confirm-btn-args deny-btn-args on-confirm on-deny primary?]
                            :or {on-deny #(re/dispatch [:modals/hide])}}]
  [modal {:background-click on-deny}
   [h/h3
    {:style {:text-align :center}
     :dark-theme-style {:color (style/dark-color :on-surface :base)}}
    (or message "Are you sure you want to perform this action?")]
   [:div {:style {:display :flex
                  :margin-top 20}}
    [button/white-button (merge {:style {:margin-right 5
                                         :width 100}
                                 :on-click on-deny}
                                deny-btn-args)
     "No"]
    [(if primary?
       button/primary-button
       button/green-button)
     (merge {:style {:margin-left 5
                     :width 100}
             :on-click on-confirm}
            confirm-btn-args)
     "Yes"]]])

(defn active-modal []
  (let [active-modal- (rf/subscribe [:modals/active-])]
    (when @active-modal-
      (let [[modal-id args] @active-modal-]
        ^{:key (pr-str args)}
        [modal-view modal-id args]))))

(defn primary-modal [{:keys [style] :as args} & contents]
  (into [modal (assoc args :style (merge {:border-radius 8}
                                         style))]
        contents))
